<template>
  <li
      class="popular-queries__item q-list-group-item q-d-flex q-justify-content-between q-align-items-start q-p-1 q-text-start"
  >
    <a v-if="queryItem?.link"
       class="q-text-decoration-none q-link-secondary popular-queries__item-link"
       :href="queryItem?.link">
      {{ queryItem.query }}
    </a>
    <a v-else class="q-text-decoration-none q-link-secondary popular-queries__item-link"
       @click.stop="handleQueryClick(queryItem.query)">{{
        queryItem.query
      }}
    </a>
    <button v-if="canRemove"
       @click.stop="userRecentQueriesStore.removeQuery(index)"
       type="button"
       class="remove-query__button q-btn q-btn-close q-btn-sm"
       aria-label="Remove"></button>
  </li>
</template>

<script lang="ts" setup>
import {inject} from 'vue'

import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {defineProps} from "vue";
import {useUserRecentQueriesStore} from "@/store/AutocompletePopup/UserRecentQueriesStore";

defineProps(['queryItem', 'index', 'canRemove'])

const urlStore = useUrlStore()
const SmartSearchConfig = inject('SmartSearchConfig').value;
const {redirectionUrl} = SmartSearchConfig.appConfiguration

const userRecentQueriesStore = useUserRecentQueriesStore()

const handleQueryClick = (query: string) => {
  const cleaned = (query || '').trim();
  if (!cleaned) return;
  
  urlStore.goToSerpPage(
      redirectionUrl,
      cleaned
  );
};

</script>
<style scoped>
.popular-queries__item-link {
  font-size: 0.75em;
  cursor: pointer;
}
.remove-query__button{
  margin-top: 8px;
  width: 10px;
  height: 10px;
}
</style>
